<template>
  <div class="to-agnet">
    <div class="text" :class="{ client: message.chatUserRole === 'Customer' }">
      <div class="content gpt-ql-editor" v-html="message.content"></div>
      <div class="time">{{ message.createAt | localTime }}</div>
    </div>
    <div class="btns">
      <a
        v-if="setting.ChatGPT_NonService_Title_1"
        :href="setting.ChatGPT_NonService_Url_1 || '#'"
        target="_blank"
        class="primary"
        >{{ setting.ChatGPT_NonService_Title_1 }}</a
      >
      <a
        v-if="setting.ChatGPT_NonService_Title_2"
        :href="setting.ChatGPT_NonService_Url_2 || '#'"
        target="_blank"
        class="primary"
        >{{ setting.ChatGPT_NonService_Title_2 }}</a
      >
    </div>
  </div>
</template>

<script>
export default {
  // AP-4871 [Chat240718-07]BOT-decision tree增加欄位for非服務時間
  name: "gpt-message-toAgent-nonService",
  props: {
    message: {
      type: Object,
    },
  },
  data() {
    return {
      display: true,
    };
  },
  computed: {
    setting() {
      return this.$store.state.gpt.setting;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "gpt.scss";
</style>
